<template>
    <div>
        <button class="btn btn-primary" @click="openModal('update-video-modal')">
            <i class="fas fa-pencil-alt"></i> Update
        </button>
        <modal id="update-video-modal">
            <template slot="title">Update Video</template>
            <template slot="body">
                <field-input v-model="form.name" placeholder="Name"></field-input>
                <field-text v-model="form.description" placeholder="Description"></field-text>
                <field-input v-model="form.playtime" placeholder="Playtime (In Minutes)"></field-input>
                <field-datetime v-model="form.published_at" :with-time="false" :clear-button="true" :emit-null="true" label="Publish Date"></field-datetime>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-default" @click="closeModal('update-video-modal')">Cancel</button>
                <button type="button" class="btn btn-success" :disabled="form.isSubmitted" @click="save()">Update</button>
            </template>
        </modal>
    </div>
</template>
<script>
    export default {

        props: {
            video: {
                required: true,
                type: Object,
            },
            serie: {
                required: true,
                type: Object,
            },
        },

        data(){
            return{
                form: new Form(this.video, false)
            }
        },

        methods: {
            save(){
                this.form.patch(`/training/series/${this.serie.slug}/videos/${this.video.id}`).then(response => {
                    this.refreshPage();
                }).catch(errors => {
                    Alert.error(errors.first());
                });
            },
        }
    }
</script>
